/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Action_RejectInputs */

const vi_sl_detail_action_reject = /** @type {(inputs: Sl_Detail_Action_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ chối`)
};

/**

* @param {Sl_Detail_Action_RejectInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_action_reject = /** @type {((inputs?: Sl_Detail_Action_RejectInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Action_RejectInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_action_reject(inputs)
});